var _path, _path2, _path3, _circle, _circle2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWinnersBadge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1115,
    height: 1499,
    viewBox: "0 0 1115 1499",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M650 1056.5L620.5 1088C642.9 1104.8 674.5 1210.33 687.5 1261C725.1 1371 811.833 1465.5 850.5 1499C831.7 1400.6 844.667 1326.33 853.5 1301.5C969.1 1380.7 1044.33 1382.83 1067.5 1374C979.1 1322.4 929.333 1197.83 915.5 1142C901.667 1086.17 883.667 1015.5 873 985H827.5L776 1110.5L650 1056.5Z",
    fill: "#FF7760"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M334 1111L292.5 1009C236 1228.5 221.5 1260.5 112 1364C198.4 1368.8 289.667 1313 324.5 1284.5C348.9 1335.7 338.333 1437.83 330 1482.5C442.8 1384.1 496.5 1250.5 528 1126L458 1057L334 1111Z",
    fill: "#FF7760"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M557.5 14.1637L642.867 99.7907L647.6 104.538L653.789 101.963L765.426 55.5227L811.526 167.3L814.082 173.498L820.786 173.487L941.697 173.303L941.513 294.214L941.502 300.918L947.7 303.474L1059.48 349.574L1013.04 461.211L1010.46 467.4L1015.21 472.133L1100.84 557.5L1015.21 642.867L1010.46 647.6L1013.04 653.789L1059.48 765.426L947.7 811.526L941.502 814.082L941.513 820.786L941.697 941.697L820.786 941.513L814.082 941.502L811.526 947.7L765.426 1059.48L653.789 1013.04L647.6 1010.46L642.867 1015.21L557.5 1100.84L472.133 1015.21L467.4 1010.46L461.211 1013.04L349.574 1059.48L303.474 947.7L300.918 941.502L294.214 941.513L173.303 941.697L173.487 820.786L173.498 814.082L167.3 811.526L55.5227 765.426L101.963 653.789L104.538 647.6L99.7907 642.867L14.1637 557.5L99.7907 472.133L104.538 467.4L101.963 461.211L55.5227 349.574L167.3 303.474L173.498 300.918L173.487 294.214L173.303 173.303L294.214 173.487L300.918 173.498L303.474 167.3L349.574 55.5227L461.211 101.963L467.4 104.538L472.133 99.7907L557.5 14.1637Z",
    fill: "white",
    stroke: "#FFAC9D",
    strokeWidth: 20
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 558,
    cy: 557,
    r: 375,
    stroke: "#FFAC9D",
    strokeWidth: 20
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 558,
    cy: 557,
    r: 345,
    fill: "#FF7760"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWinnersBadge);
export default __webpack_public_path__ + "static/media/winners_badge.342ee240365577ced0c3ae72ebbc2fba.svg";
export { ForwardRef as ReactComponent };